<template>
  <div class="material-table">
    <div class="material-table__actions mb15">
      <div></div>
      <a-button type="primary" @click="add">加入待选 >></a-button>
    </div>

    <!-- <a-table
      row-key="materialId"
      size="small"
      :bordered="true"
      :loading="loading"
      :data-source="records"
      :columns="columns"
      :scroll="{ x: true }"
      :pagination="false"
      :row-selection="{
        selectedRowKeys: selectedIds,
        onChange: onSelectionChange,
        fixed: true,
      }"
    > -->
    <table-wrapper
      :data-config="{ format: dataFormat }"
      :loading="loading"
      :row-key="'materialId'"
      size="small"
      ref="tableRef"
      :bordered="true"
      :data-source="records"
      :columns="columns"
      :tableHeight="tableHeight"
      @onSelectionChange="onSelectionChange"
    >
      <template #budgetPrice="{ record }">
        {{ $filters.formatMoney(record.budgetPrice) }}
      </template>
      <template #taxPrice="{ record }">
        {{ $filters.formatMoney(record.taxPrice) }}
      </template>
      <template #taxTotalPrice="{ record }">
        {{ $filters.formatMoney(record.taxTotalPrice) }}
      </template>
      <template #totalPrice="{ record }">
        {{ $filters.formatMoney(record.totalPrice) }}
      </template>
    </table-wrapper>
  </div>
</template>

<script lang="ts">
import _ from "lodash";
import { defineComponent, onMounted, reactive, toRefs, watch, computed, PropType } from "vue";
import { ContractService } from "@/views/purchase/contract/contract.service";
import { DetailRecord } from "@/views/purchase/contract/contract.interface";
import { aloneColumns, frameColumns } from "./constant";

export default defineComponent({
  name: "MaterialTable",
  props: {
    contractId: { type: String, default: "" },
    tableHeight: {
      type: Number,
      default: 0,
    },
    value: { type: Array as PropType<DetailRecord[]>, default: [] },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      keyword: string;
      selectedIds: string[];
      selectedRows: DetailRecord[];
      selectedList: any[];
      columns: any[];
      records: any[];
    }>({
      keyword: "",
      selectedIds: [],
      selectedRows: [],
      selectedList: [],
      columns: [],
      records: [],
    });

    const { loading, run } = ContractService.useDetailApi();

    const search = async () => {
      const res = await run(props.contractId);
      if (res.respCode === "0000" && res.data) {
        const { purchaseContractAResp, purchaseContractDetailAResps } = res.data;
        if (purchaseContractAResp.purchaseContractType === "dccg") {
          state.columns = aloneColumns;
        }
        if (purchaseContractAResp.purchaseContractType === "kjcg") {
          state.columns = frameColumns;
        }
        state.records = purchaseContractDetailAResps;
      }
    };

    const onSelectionChange = ({ids, selectedRows}) => {
      state.selectedIds = ids;
      state.selectedRows = selectedRows;
    };

    const add = () => {
      const newValue = [...props.value, ...state.selectedRows];
      emit("update:value", _.uniqBy(newValue, "id"));
    };

    onMounted(async () => {
      await search();
    });

    watch(
      () => props.value,
      async (newVal) => {
        const ids = (newVal || []).map((item) => item.materialId);
        state.selectedIds = ids;
      },
      { immediate: true }
    );
    //切换合同，采购明细要跟着变
    watch(()=>props.contractId,(n)=>{
      if(n){
        search()
      }
    })
    const dataFormat = (rows) => {
      let ids = rows.reduce((pre, cur) => {
        pre.push(cur.id);
        return pre;
      }, []);
      return {
        ids,
        selectedRows: rows,
      };
    };
    return {
      ...toRefs(state),
      loading,
      search,
      onSelectionChange,
      add,
      dataFormat,
    };
  },
});
</script>

<style lang="less" scoped>
.material-table {
  &__actions {
    display: flex;
    justify-content: space-between;
  }
}
</style>
